import { get, post, put, postBlob } from "@/utils/api";

export const CustomerAPI = {
    query: async (params) => {
        return await get("/customer", params);
    },
    actives: async () => {
        return await get("/customer/actives");
    },
    get: async (id) => {
        return await get(`/customer/${id}`);
    },
    balance: async (id) => {
        return await get(`/customer/${id}/balance`);
    },
    balanceDetails: async (id) => {
        return await get(`/customer/${id}/balance-details`);
    },
    add: async (params) => {
        return await put("/customer", params);
    },
    update: async (id, params) => {
        return await post(`/customer/${id}`, params);
    },
    enable: async (id) => {
        return await post(`/customer/${id}/1`);
    },
    disable: async (id) => {
        return await post(`/customer/${id}/2`);
    },
    addresses: async (id) => {
        return await get("/customer/address", { customerId: id })
    },
    openInvoiceCustomers: async () => {
        return await get("/customer/open-invoice");
    },
    contacts: async (customerId, tags) => {
        return await get("/customer/contact", { customerId: customerId, tags: tags });
    },
    accountManagers: async () => {
        return await get("/customer/account-managers");
    }
}

export const SOAPI = {
    query: async (page, params) => {
        const criteria = { page: page, ...params };
        return await get("/so", criteria);
    },
    actives: async () => {
        return await get("/so/active");
    },
    get: async (id) => {
        return await get(`/so/${id}`);
    },
    inventoryItems: async (id) => {
        return await get(`/so/${id}/items?itemType=1`);
    },
    add: async (values) => {
        return await put("/so", values);
    },
    update: async (id, values) => {
        return await post(`/so/${id}`, values);
    },
    issue: async (id) => {
        return await post(`/so/${id}/issue`);
    },
    unissue: async (id) => {
        return await post(`/so/${id}/unissue`);
    },
    shortClose: async (id) => {
        return await post(`/so/${id}/short-close`);
    },
    voidSO: async (id) => {
        return await post(`/so/${id}/void`);
    },
    fulfillments: async (id) => {
        return await get(`/so/${id}/fulfillment`);
    },
    noInvoiceFulfillments: async (soId) => {
        return await get(`/so/${soId}/no-invoice-fulfillment`);
    },
    fulfillmentItems: async (soId) => {
        return await get(`/so/${soId}/fulfillment-items`);
    },
    print: async (soId) => {
        return await postBlob(`/so/${soId}/print`);
    },
    getEmail: async (soId) => {
        return await post(`/so/${soId}/email/content`);
    },
    sendEmail: async (soId, params) => {
        return await post(`/so/${soId}/email/send`, params);
    },
    getCustomerLastSOItem: async (customerId, itemId) => {
        if (!customerId || !itemId) return;
        return await get(`/so/customer/${customerId}/item/${itemId}/last`);
    },
    getNonInventoryItems: async (soId) => {
        return await get(`/so/${soId}/items?itemType=2`);
    },
    report: async (params) => {
        return await get("/so/report", params)
    },
    export: async (params) => {
        return await postBlob("/so/export", params);
    },
    updateNote: async (id, note) => {
        return await post(`/so/${id}/note`, { note });
    },
    openCustomers: async () => {
        return await get("/so/open/customers");
    },
    openItems: async () => {
        return await get("/so/open/items");
    },
    getRecentSales: async (params) => {
        return await get(`/so/recent-sales`, params);
    },
    getLastSales: async (params) => {
        return await get(`/so/last-sales`, params);
    },
    exportRecentSales: async (params, queryParams) => {
        return await postBlob("/so/export/recent-sales", params, queryParams);
    },
    exportLastSales: async (params) => {
        return await postBlob("/so/export/last-sales", params);
    },
    getItemReport: async (params) => {
        return await get(`/so/item/report`, params);
    },
}

export const SOPOAPI = {
    query: async (page, params) => {
        return await get("/so-pick-order", { page: page, ...params });
    },
    estimate: async (soId, warehouseId) => {
        return await get(`/so-pick-order/estimate/${soId}?warehouseId=${warehouseId}`);
    },
    get: async (id) => {
        return await get("/so-pick-order/" + id);
    },
    getBySO: async (id) => {
        return await get("/so-pick-order/so/" + id);
    },
    getUnfulfilledBySO: async (soId) => {
        return await get(`/so-pick-order/so/${soId}/unfulfilled`);
    },
    add: async (values) => {
        return await put("/so-pick-order", values);
    },
    update: async (sopoId, params) => {
        return await post(`/so-pick-order/${sopoId}`, params);
    },
    print: async (sopoId) => {
        return await postBlob(`/so-pick-order/${sopoId}/print`);
    },
    getEmail: async (id) => {
        return await post(`/so-pick-order/${id}/email/content`);
    },
    sendEmail: async (id, params) => {
        return await post(`/so-pick-order/${id}/email/send`, params);
    },
    voidPO: async (sopoId) => {
        return await post(`/so-pick-order/${sopoId}/void`);
    },
    report: async (params) => {
        return await get("/so-pick-order/report", params)
    },
    exportReport: async (params) => {
        return await postBlob("/so-pick-order/report/export", params);
    },
}

export const SOFulfillmentAPI = {
    query: async (page, params) => {
        return await get("/so-fulfillment", { page: page, ...params });
    },
    items: async (page, params) => {
        return await get(`/so-fulfillment/items`, { page: page, ...params });
    },
    exportItems: async (params) => {
        return await postBlob("/so-fulfillment/recall/export", params);
    },
    get: async (id) => {
        return await get(`/so-fulfillment/${id}`);
    },
    add: async (values) => {
        return await put("/so-fulfillment", values);
    },
    update: async (id, values) => {
        return await post(`/so-fulfillment/${id}`, values);
    },
    voidFulfillment: async (fulfillmentId) => {
        return await post(`/so-fulfillment/${fulfillmentId}/void`)
    },
    print: async (fulfillmentId) => {
        return await postBlob(`/so-fulfillment/${fulfillmentId}/print`);
    },
    getEmail: async (fulfillmentId) => {
        return await post(`/so-fulfillment/${fulfillmentId}/email/content`);
    },
    sendEmail: async (fulfillmentId, params) => {
        return await post(`/so-fulfillment/${fulfillmentId}/email/send`, params);
    },
    report: async (params) => {
        return await get("/so-fulfillment/report", params)
    },
    exportReport: async (params) => {
        return await postBlob("/so-fulfillment/report/export", params);
    },
}

export const InvoiceAPI = {
    query: async (page, params) => {
        return await get("/invoice", { page: page, ...params });
    },
    get: async (id) => {
        return await get(`/invoice/${id}`);
    },
    add: async (values) => {
        return await put("/invoice", values);
    },
    update: async (id, values) => {
        return await post(`/invoice/${id}`, values);
    },
    voidInvoice: async (id) => {
        return await post(`/invoice/${id}/void`);
    },
    print: async (invoiceId) => {
        return await postBlob(`/invoice/${invoiceId}/print`);
    },
    getEmail: async (id) => {
        return await post(`/invoice/${id}/email/content`);
    },
    sendEmail: async (id, params) => {
        return await post(`/invoice/${id}/email/send`, params);
    },
    actives: async (params) => {
        return await get("/invoice/actives", params);
    },
    payments: async (invoiceId) => {
        return await get(`/invoice/${invoiceId}/payments`);
    },
    getCustomerLastInvoiceItem: async (customerId, itemId) => {
        if (!customerId || !itemId) return;
        return await get(`/invoice/customer/${customerId}/item/${itemId}/last`);
    },
    getItemsBySoId: async (soId) => {
        return await get(`/invoice/so/${soId}/items`);
    },
    getTotalBalance: async (params) => {
        return await get("/invoice/total-balance", params);
    },
    getTotalPastDue: async (params) => {
        return await get("/invoice/total-past-due", params);
    },
    download: async (params) => {
        return await postBlob("/invoice/download", params);
    },
    getAccountStatementTemplate: async () => {
        return await get("/invoice/account-statement-template");
    },
    sendInvoiceList: async (params) => {
        return await post(`/invoice/send-with-invoice-list`, params);
    }
}
